import { Badge, Button } from "@devhop/ui";
import {
  LOG_STATUS_FILTER_OPTIONS,
  QUEUE_STATUS_FILTER_OPTIONS,
} from "./notification-table-badges";

type NotificationRecordsFilterBarProps = {
  mode: "logs" | "queue";
  status: string;
  onStatusChange: (status: string) => void;
  filteredTotal: number;
};

export function NotificationRecordsFilterBar({
  mode,
  status,
  onStatusChange,
  filteredTotal,
}: NotificationRecordsFilterBarProps) {
  const options =
    mode === "logs" ? LOG_STATUS_FILTER_OPTIONS : QUEUE_STATUS_FILTER_OPTIONS;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-muted-foreground text-xs">ສະຖານະ:</span>
        {options.map((opt) => {
          const active = status === opt.key;

          return (
            <Button
              key={opt.key}
              type="button"
              size="sm"
              variant={active ? "default" : "outline"}
              className="h-8"
              onClick={() => onStatusChange(opt.key)}
            >
              {opt.label}
            </Button>
          );
        })}
      </div>
      <Badge variant="outline" className="tabular-nums">
        {filteredTotal.toLocaleString("lo-LA")} ລາຍການ
      </Badge>
    </div>
  );
}
